import { node, string } from "prop-types";
import { FormattedMessage } from "react-intl";

import viperLogo from "@/images/svgs/viper.svg";
import { Message, Subtitle, TextWrapper, Title, Wrapper } from "./styled";

const PageError = ({ title, subtitle, children }) => {
  if (import.meta.env.DEV)
    console.info(
      "If you're seeing this error page unexpectedly, make sure Cosmos is running locally."
    );

  return (
    <Wrapper>
      <TextWrapper>
        <img src={viperLogo} alt="viper" />
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        <Message>
          <FormattedMessage id="pageErrors.contactSystemAdmin" />
        </Message>
        {children}
      </TextWrapper>
    </Wrapper>
  );
};

PageError.propTypes = {
  title: string.isRequired,
  subtitle: string.isRequired,
  children: node,
};

export default PageError;
